'use client';
/* Built In Imports */
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Image,
  List,
  ListItem,
  Text,
  useOutsideClick,
} from '@chakra-ui/react';
import { FaCaretDown, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

/* Internal Imports */
import { nanoid } from 'nanoid';
// import HeaderStyle from './HeaderStyle';
/* Components */

/**
 *
 * @returns
 */
const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [menuIndex, setMenuIndex] = useState(-1);
  const [toggle, setToggle] = useState(false);
  const [mtoggle, setMtoggle] = useState(false);

  const menuList = [
    {
      name: 'Kailash Manasarovar',
      url: '/sacred-walks/kailash-manasarovar-yatra',
    },
    { name: 'Himalayas', url: '/sacred-walks/himalayas-yatra' },
    { name: 'Kashi Krama', url: '/sacred-walks/kashi-krama-yatra' },
    { name: 'Southern Sojourn', url: '/sacred-walks/southern-sojourn-yatra' },
  ];

  const subMenuItems = [
    { name: 'About Yatra', url: '' },
    { name: 'Itinerary', url: 'itinerary' },
    { name: 'Dates & Registrations', url: 'dates-registration' },
    { name: 'Program Guide', url: 'program-guide' },
    { name: 'Prerequisities', url: 'prerequisites' },
    { name: 'Conveniences Offered', url: 'conveniences-offered' },
    { name: "FAQ's", url: 'faqs' },
    { name: 'Gallery', url: 'gallery' },
  ];

  // const otherMenuList = [
  //   { name: 'Enquire Now', url: '/sacred-walks/enquire-now' },
  //   { name: 'Register', ur: '/sacred-walks/register-now' },
  //   { name: 'Contact Us', url: '/sacred-walks/contact-us' },
  // ];
  const router = useRouter();
  const ref = useRef();
  const ref2 = useRef();

  useOutsideClick({
    ref: ref,
    handler: () => setToggle(false),
  });

  useEffect(() => {
    router?.events?.on('routeChangeStart', () => {
      setMtoggle(false);
      setToggle(false);
    });
  }, []);

  useEffect(() => {
    if (mtoggle) {
      ref2.current.focus();
    }
  }, [mtoggle]);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const heightToHideFrom = window.innerHeight;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  return (
    <Box
      height="100%"
      w="100%"
      //maxW={1300}
      mx="auto"
      h={{ md: isVisible ? '140px' : 0, base: 'auto' }}
      pos="fixed"
      top="0"
      left="0"
      zIndex="30"
    >
      <Box
        className="sticky-menu"
        h="100px"
        background="linear-gradient(180deg, rgb(0 0 0 / 72%) 18%, rgb(0 0 100 / 0%) 83%)"
        display={isVisible ? 'block' : 'none'}
      >
        <Flex className="desktop">
          <Box
            display="flex"
            flexDirection="row"
            mx="auto"
            pt="4px"
            pl="10px"
            px="16px"
            w="100%"
            justifyContent="space-between"
          >
            <Box>
              {/* <NextLink href="/sacred-walks" passHref legacyBehavior> */}
              <Link href="/sacred-walks" _focus={{ boxShadow: 'none' }}>
                <Image
                  mx="auto"
                  cursor="pointer"
                  userSelect="none"
                  maxW={{ base: '143.31px', lg: '129px' }}
                  height={{ lg: '100%', base: 'auto' }}
                  maxHeight="60px"
                  pt="20px"
                  src="/assets/images/IshaSacredWalks_Logo_EN_White12.png"
                  alt="IshaSacredWalks"
                />
              </Link>
              {/* </NextLink> */}
            </Box>
            <Box
              ref={ref}
              direction="row"
              mr="0px"
              display="flex"
              justifyItems="center"
              gridGap={{ md: '18px', lg: '28px' }}
              color="#FFF"
              fontFamily="var(--FedraSansStdMedium)"
              fontSize="16px"
              lineHeight={{ md: '21.65px', base: '17.5px' }}
            >
              <Box>
                <Box
                  display="flex"
                  pt="30px"
                  transition="padding-right 0.3s"
                  pr={toggle ? '310px' : '0px'}
                >
                  <Flex flexDirection="row" border="none">
                    <Box pr="27px"></Box>

                    {menuList.map((navItem, index) => {
                      return (
                        <Box
                          key={nanoid()}
                          pr="27px"
                          pos="relative"
                          fontSize={{ md: '16px', base: '14px' }}
                        >
                          <Box
                            onMouseOver={() => {
                              setMenuIndex(index);
                            }}
                            onMouseOut={() => {
                              setMenuIndex(false);
                            }}
                            className="mainMenu"
                          >
                            {/* <NextLink
                                  href={navItem.url}
                                  passHref
                                  legacyBehavior
                                > */}
                            <Link
                              href={navItem.url}
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                            >
                              {navItem.name}
                            </Link>
                            {/* </NextLink> */}

                            <Box
                              pos="absolute"
                              pt="5px"
                              w="max-content"
                              fontSize={{ md: '14px', base: '14px' }}
                            >
                              {menuIndex === index && (
                                <List
                                  bg="black"
                                  p="10px 15px"
                                  className="list"
                                  borderRadius="5px"
                                  opacity="0.8"
                                  w="100%"
                                >
                                  {/* <NextLink
                                        href={`${navItem.url}`}
                                        passHref
                                        legacyBehavior
                                      > */}
                                  {subMenuItems?.map(submenu => {
                                    return (
                                      <Link
                                        key={nanoid()}
                                        href={`${navItem.url}/${submenu.url}`}
                                        _hover={{
                                          textDecoration: 'none',
                                          color: '#c85333',
                                        }}
                                        _focus={{ boxShadow: 'none' }}
                                      >
                                        <ListItem
                                          pt={
                                            submenu.name === 'About Yatra'
                                              ? '5px'
                                              : '15px'
                                          }
                                        >
                                          {submenu.name}
                                        </ListItem>
                                      </Link>
                                    );
                                  })}
                                </List>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                    <Box pr="27px">
                      <List>
                        <ListItem>
                          <Link
                            href="/sacred-walks/enquire-now"
                            _hover={{
                              textDecoration: 'none',
                              color: '#c85333',
                            }}
                            _focus={{ boxShadow: 'none' }}
                            cursor="pointer"
                          >
                            Enquire Now
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </Flex>
                  <Flex gridColumnGap="27px">
                    <Link
                      href="tel:+918144123123"
                      _hover={{ textDecoration: 'none', color: '#c85333' }}
                      _focus={{ boxShadow: 'none' }}
                    >
                      <FaPhoneAlt fontSize="18px" />
                    </Link>
                    <Link
                      target="_blank"
                      href="https://wa.me/918144123123"
                      _hover={{ textDecoration: 'none', color: '#c85333' }}
                      _focus={{ boxShadow: 'none' }}
                    >
                      <FaWhatsapp fontSize="18px" />
                    </Link>

                    <Box>
                      <Box
                        onClick={() => setToggle(!toggle)}
                        transform={toggle ? 'rotate(-90deg)' : ''}
                        cursor="pointer"
                        mt="-4px"
                      >
                        <FaCaretDown fontSize="25px" />
                      </Box>

                      {toggle ? (
                        <Box
                          //   overflow="auto"
                          //  pos="sticky"

                          maxH="auto"
                          maxW="310"
                          minW="300px"
                          w="100%"
                          background="#000"
                          h="100vh"
                          color="#fff"
                          position="absolute"
                          top="0"
                          pr="0px"
                          right="0"
                          ml="32px"
                          // right='-5px'

                          fontFamily="var(--FedraSansStdMedium)"
                        >
                          <Box alignItems="center" pt="30px">
                            <Box
                              w="126px"
                              h="126px"
                              textAlign="center"
                              ml="85px"
                              borderRadius="50%"
                              boderColor="#fff"
                              border="2px"
                            ></Box>
                            <Link
                              onClick={() => setToggle(false)}
                              href="/sacred-walks"
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                            >
                              <Image
                                w="106px"
                                h="49px"
                                alignItems="center"
                                ml="95px"
                                mt="-90px"
                                src="/assets/images/IshaSacredWalks_Logo_EN_White12.png"
                                alt=""
                              />
                            </Link>
                            {/* </NextLink> */}
                          </Box>
                          <Text textAlign="center" mt="60px">
                            A Journey of a life time
                          </Text>
                          <Text
                            borderBottom="2px"
                            mt="20px"
                            borderBottomColor="white"
                            mx="auto"
                            w="90%"
                          ></Text>
                          <Box
                            overflowY="auto"
                            h={{ '2xl': '70vh', xl: '70vh' }}
                          >
                            <Link
                              // onClick={() => setToggle(false)}
                              href="/sacred-walks/"
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              onClick={() => setToggle(false)}
                            >
                              <Text
                                mt="15px"
                                pl="20px"
                                fontSize={{ md: '19px' }}
                                lineHeight={{ md: '28px' }}
                              >
                                Home
                              </Text>
                            </Link>
                            <Link
                              // onClick={() => setToggle(false)}
                              href="/sacred-walks/about-us"
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              onClick={() => setToggle(false)}
                            >
                              <Text
                                mt="25px"
                                pl="20px"
                                fontSize={{ md: '19px' }}
                                lineHeight={{ md: '28px' }}
                                border="none"
                              >
                                About Us
                              </Text>
                            </Link>
                            <Accordion
                              borderBottom="none"
                              allowToggle={true}
                              mb="25px"
                            >
                              {' '}
                              {menuList.map(navItem => {
                                return (
                                  <AccordionItem
                                    borderTop="none"
                                    borderBottom="none"
                                    key={nanoid()}
                                  >
                                    <Box as="h2">
                                      <AccordionButton
                                        className="test"
                                        border="none"
                                        boxShadow="none"
                                        m="20px 0px -5px -15px"
                                        _focus={{ boxShadow: 'none' }}
                                      >
                                        <Box
                                          as="span"
                                          flex="1"
                                          fontSize={{ md: '19px' }}
                                          pl="20px"
                                          lineHeight={{ md: '28px' }}
                                          textAlign="left"
                                          _hover={{ color: '#c85333' }}
                                          _active={{ color: '#c85333' }}
                                        >
                                          {navItem.name}
                                        </Box>
                                        <FaCaretDown />
                                      </AccordionButton>
                                    </Box>
                                    <AccordionPanel
                                      background="#131313"
                                      border="none"
                                      pl="45px"
                                      mt="5px"
                                      _focus={{ boxShadow: 'none' }}
                                    >
                                      <List fontSize={{ md: '16px' }} pl="10px">
                                        {subMenuItems?.map(subItem => {
                                          return (
                                            <Link
                                              key={nanoid()}
                                              href={`${navItem.url}/${subItem.url}`}
                                              onClick={() => setToggle(false)}
                                              _hover={{
                                                textDecoration: 'none',
                                                color: '#c85333',
                                              }}
                                              _focus={{ boxShadow: 'none' }}
                                            >
                                              <ListItem
                                                pt={
                                                  subItem.name === 'About Yatra'
                                                    ? '5px'
                                                    : '10px'
                                                }
                                              >
                                                {subItem.name}
                                              </ListItem>
                                            </Link>
                                          );
                                        })}
                                      </List>
                                    </AccordionPanel>
                                  </AccordionItem>
                                );
                              })}
                            </Accordion>
                            <Link
                              href="/sacred-walks/enquire-now"
                              // onClick={() => setToggle(false)}
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              key={nanoid()}
                              onClick={() => setToggle(false)}
                            >
                              <Text
                                mt="25px"
                                pl="20px"
                                fontSize={{ md: '19px' }}
                                lineHeight={{ md: '28px' }}
                                _focus={{ boxShadow: 'none' }}
                              >
                                Enquire Now
                              </Text>
                            </Link>
                            <Link
                              href="/sacred-walks/register-now"
                              // onClick={() => setToggle(false)}
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              key={nanoid()}
                              onClick={() => setToggle(false)}
                            >
                              <Text
                                mt="25px"
                                pl="20px"
                                fontSize={{ md: '19px' }}
                                lineHeight={{ md: '28px' }}
                                _focus={{ boxShadow: 'none' }}
                              >
                                Register
                              </Text>
                            </Link>
                            <Link
                              href="/sacred-walks/contact-us"
                              // onClick={() => setToggle(false)}
                              _hover={{
                                textDecoration: 'none',
                                color: '#c85333',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              key={nanoid()}
                              onClick={() => setToggle(false)}
                            >
                              <Text
                                mt="25px"
                                pl="20px"
                                fontSize={{ md: '19px' }}
                                lineHeight={{ md: '28px' }}
                                _focus={{ boxShadow: 'none' }}
                              >
                                Contact Us
                              </Text>
                            </Link>
                          </Box>
                        </Box>
                      ) : (
                        ''
                      )}
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
        </Flex>

        <Flex pt={{ base: '10px', md: '20px' }} className="mobile">
          <Box
            display="flex"
            maxW={1200}
            flexDirection="row"
            mx="auto"
            w="95%"
            h="auto"
            justifyContent="space-between"
          >
            <Box mt="10px" h="auto" w="30%">
              {/* <NextLink href="/sacred-walks" passHref legacyBehavior> */}
              <Link _focus={{ boxShadow: 'none' }} href="/sacred-walks">
                <Image
                  mx="10px"
                  cursor="pointer"
                  position="fixed"
                  userSelect="none"
                  maxW={{ base: '110px', md: '120px', lg: '160px' }}
                  height={{ lg: 'auto', base: 'auto' }}
                  //pt="5px"
                  src="/assets/images/IshaSacredWalks_Logo_EN_White12.png"
                  alt="IshaSacredWalks"
                />
              </Link>
              {/* </NextLink> */}
            </Box>

            <Box h="auto" w="70%" pt="20px">
              {!mtoggle ? (
                <Box
                  ml={{
                    xl: '95%',
                    lg: '95%',
                    md: '90%',
                    base: '87%',
                    sm: '90%',
                  }}
                >
                  <HamburgerIcon
                    width={{ base: '20px', md: '20px', xl: '25px' }}
                    height={{ base: '20px', md: '20px', xl: '25px' }}
                    //mt="10px"
                    color="#fff"
                    onClick={() => setMtoggle(true)}
                  />
                </Box>
              ) : (
                <Box
                  ml={{
                    xl: '95%',
                    lg: '95%',
                    md: '92%',
                    base: '87%',
                    sm: '90%',
                  }}
                  w="100%"
                >
                  <CloseIcon
                    //  class="closeIcon"
                    width={{ base: '15px', md: '18px', xl: '25px' }}
                    height={{ base: '15px', md: '18px', xl: '25px' }}
                    onClick={() => {
                      setMtoggle(false);
                    }}
                    color="#fff"
                  />
                </Box>
              )}
            </Box>
          </Box>
          <Box w="100%">
            {mtoggle && (
              <Box
                ref={ref2}
                tabIndex={0}
                maxW="100%"
                minW="300px"
                w="767px"
                background="rgba(0,0,0,0.90)!important"
                h="100vh"
                maxH="auto"
                color="#fff"
                position="absolute"
                //   maxH="auto"
                top={{ base: '95px', md: '95px', lg: '105px' }}
                right="0"
                opacity="1.0"
                transition="right 1.3s"
                fontFamily="var(--FedraSansStdMedium)"
              >
                <Text
                  borderBottom="4px"
                  mt="20px"
                  borderBottomColor="white"
                  mx="auto"
                  w="90%"
                ></Text>
                <Box
                  w="100%"
                  overflowY="auto"
                  h={{ base: '80vh', md: '75vh', lg: '90vh' }}
                  top="0"
                  bottom="0"
                >
                  <Link
                    href="/sacred-walks/"
                    _hover={{
                      textDecoration: 'none',
                      color: '#c85333',
                    }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => setMtoggle(false)}
                  >
                    <Text
                      mt="15px"
                      pl="20px"
                      fontSize={{ md: '19px' }}
                      lineHeight={{ md: '28px' }}
                    >
                      Home
                    </Text>
                  </Link>

                  <Link
                    href="/sacred-walks/about-us"
                    _hover={{
                      textDecoration: 'none',
                      color: '#c85333',
                    }}
                    _focus={{ boxShadow: 'none', backgroundColor: 'none' }}
                    onClick={() => setMtoggle(false)}
                  >
                    <Text
                      mt="25px"
                      pl="20px"
                      fontSize={{ md: '19px' }}
                      lineHeight={{ md: '28px' }}
                      border="none"
                    >
                      About Us
                    </Text>
                  </Link>
                  <Accordion border="none" allowToggle={true} mb="25px">
                    {menuList.map(navItem => {
                      return (
                        <AccordionItem
                          key={nanoid()}
                          borderTop="none"
                          borderBottom="none"
                        >
                          <Box as="h2">
                            <AccordionButton
                              className="test"
                              border="none"
                              boxShadow="none"
                              m="20px 0px -5px -15px"
                              _focus={{ boxShadow: 'none' }}
                            >
                              <Box
                                as="span"
                                flex="1"
                                fontSize={{ md: '19px' }}
                                pl="20px"
                                lineHeight={{ md: '28px' }}
                                textAlign="left"
                                _hover={{ color: '#c85333' }}
                                _active={{ color: '#c85333' }}
                              >
                                {navItem.name}
                              </Box>
                              <FaCaretDown />
                            </AccordionButton>
                          </Box>
                          <AccordionPanel
                            background="#131313"
                            border="none"
                            pl="45px"
                            mt="5px"
                            _focus={{ boxShadow: 'none' }}
                          >
                            <List fontSize={{ md: '16px' }} pl="10px">
                              {/* <NextLink
                            href="/sacred-walks/kailash-manasarovar-yatra"
                            passHref
                            legacyBehavior
                          > */}
                              {subMenuItems?.map(subItem => {
                                return (
                                  <Link
                                    key={nanoid()}
                                    href={`${navItem.url}/${subItem.url}`}
                                    _hover={{
                                      textDecoration: 'none',
                                      color: '#c85333',
                                    }}
                                    _focus={{ boxShadow: 'none' }}
                                    onClick={() => setMtoggle(false)}
                                  >
                                    <ListItem
                                      pt={
                                        subItem.name === 'About Yatra'
                                          ? '5px'
                                          : '15px'
                                      }
                                    >
                                      {subItem.name}
                                    </ListItem>
                                  </Link>
                                );
                              })}
                            </List>
                          </AccordionPanel>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                  {/* {otherMenuList?.map(list => {
                    return (
                      <Link
                        key={nanoid()}
                        href={list.url}
                        onClick={() => setToggle(false)}
                        _hover={{
                          textDecoration: 'none',
                          color: '#c85333',
                        }}
                        _focus={{ boxShadow: 'none' }}
                      >
                        <Text
                          mt="25px"
                          pl="20px"
                          fontSize={{ md: '19px' }}
                          lineHeight={{ md: '28px' }}
                          _focus={{ boxShadow: 'none' }}
                        >
                          {list.name}
                        </Text>
                      </Link>
                    );
                  })} */}
                  <Link
                    key={nanoid()}
                    href="/sacred-walks/enquire-now"
                    // onClick={() => setToggle(false)}
                    _hover={{
                      textDecoration: 'none',
                      color: '#c85333',
                    }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => setMtoggle(false)}
                  >
                    <Text
                      mt="25px"
                      pl="20px"
                      fontSize={{ md: '19px' }}
                      lineHeight={{ md: '28px' }}
                      _focus={{ boxShadow: 'none' }}
                    >
                      Enquire Now
                    </Text>
                  </Link>
                  <Link
                    href="/sacred-walks/register-now"
                    // onClick={() => setToggle(false)}
                    _hover={{
                      textDecoration: 'none',
                      color: '#c85333',
                    }}
                    _focus={{ boxShadow: 'none' }}
                    key={nanoid()}
                    onClick={() => setMtoggle(false)}
                  >
                    <Text
                      mt="25px"
                      pl="20px"
                      fontSize={{ md: '19px' }}
                      lineHeight={{ md: '28px' }}
                      _focus={{ boxShadow: 'none' }}
                    >
                      Register
                    </Text>
                  </Link>
                  <Link
                    href="/sacred-walks/contact-us"
                    // onClick={() => setToggle(false)}
                    _hover={{
                      textDecoration: 'none',
                      color: '#c85333',
                    }}
                    _focus={{ boxShadow: 'none' }}
                    key={nanoid()}
                    onClick={() => setMtoggle(false)}
                  >
                    <Text
                      mt="25px"
                      pl="20px"
                      fontSize={{ md: '19px' }}
                      lineHeight={{ md: '28px' }}
                      _focus={{ boxShadow: 'none' }}
                    >
                      Contact
                    </Text>
                  </Link>
                </Box>
              </Box>
            )}
          </Box>
        </Flex>
        <Box></Box>
      </Box>
      {/* <HeaderStyle /> */}
    </Box>
  );
};

export default Header;
